const titleBasis = "Glide";

export function pageTitleForAppTitle(appTitle: string | undefined): string {
    // Ensure that this is the same as the <title> from index.html
    if (appTitle !== undefined) {
        return `${appTitle} · ${titleBasis}`;
    }
    return titleBasis;
}
